import React from 'react'
import { Text } from '@usap/uicomponents'

const UnitPrice = props => {
  const { itemPriceParsed, isWmoEnabled = false, multipleItemsPresent } = { ...props }

  if (isWmoEnabled) {
    return (
      <Text
        color="dark-2"
        style={{
          fontSize: multipleItemsPresent ? "14px" : "12px",
          fontWeight: 400,
          lineHeight: "20px"
        }}
      >
        {'Unit Price: '}
        <Text
          color="dark-2"
          style={{
            fontSize: multipleItemsPresent ? "14px" : "12px",
            fontWeight: multipleItemsPresent ? 600 : 400,
          }}
        >
          $
          {itemPriceParsed.toFixed(2)}
        </Text>
      </Text>
    )
  }

  return (
    <Text
      size="small"
      color="#333333"
      style={{
        fontWeight: 400,
      }}
    >
      {'Unit Price: '}
      $
      {itemPriceParsed.toFixed(2)}
    </Text>
  )
}

export default UnitPrice
